angular.module('CarsSaraBo').controller('SpecialOffersController', [
	'$scope', '$routeParams', '$location', '$cookies', '$rootScope',
	'SpecialOfferService', 'GAService', 'SpecialOfferGAConfig', 'NotificationService', 'SpecialOfferUrlsService',
	'CompanyService',
	function (
		$scope, $routeParams, $location, $cookies, $rootScope, 
		specialOfferService, gaService, analyticsConfig, notificationService, specialOfferUrlsService,
		companyService) {

		var UPGRADE_CAR_MODAL = 'upgrade_car_modal';

		$scope.initialize = function () {
			$scope.pagination = {
				itemsPerPage: 10,
				currentPage: 1,
				numPages: 0,
				totalItems: 0
			};
			$scope.companyOid = $routeParams.companyOid;
			$scope.approvalStatusFilter = [
				{value: 'APPROVED', label: 'specialOffers.list.filters.approvalStatus.approved'},
				{value: 'PENDING', label: 'specialOffers.list.filters.approvalStatus.pending'},
				{value: 'REJECTED', label: 'specialOffers.list.filters.approvalStatus.rejected'}
			];
			$scope.promoTypeFilter = [
				{value: 'UPGRADE_CAR', label: 'specialOffers.UPGRADE_FILTER'},
				{value: 'DISCOUNT', label: 'specialOffers.DISCOUNT_FILTER'}
			];
			$scope.filters = {
				valid: true, 
				companyOid: $routeParams.companyOid
			};
			$scope.specialOffers = [];
			$scope.isEmptyState = false;
			$scope.isNoMatchedOffers = false;
			$scope.editableSpecialOffer = $scope.loggedUserAllowed('PERM_SPECIAL_OFFER_CREATE');
			$scope.moderableSpecialOffer = $scope.loggedUserAllowed('PERM_SPECIAL_OFFER_MODERATE');
			$scope.getSpecialOffers();

			initializeCompanyInfo();
		};

		var initializeCompanyInfo = function () {
			companyService.get({oid: $scope.companyOid}, function (company) {
				$scope.setCompanyToRepresent(company);
			});
		};

		var gaModerate = analyticsConfig.moderateGa();

		$scope.getSpecialOffers = function () {
			$scope.showProgressBar();

			if ($scope.filters.valid || $scope.filters.approvalStatus || $scope.filters.specialOfferType) {
				specialOfferService.fetchByCompany($scope.companyOid, $scope.filters, $scope.pagination.currentPage, 10)
					.then(function (response) {
						setPaginationValues(response);
						$scope.specialOffers = response.items;
						$scope.isNoMatchedOffers = false;
						
						if (_.isEmpty($scope.specialOffers)) {
							// get all offers by company oid
							specialOfferService.fetchByCompany($scope.companyOid,{}, $scope.pagination.currentPage, 10)
								.then(function (notFilteredResponse) {
									$scope.isEmptyState = _.isEmpty(notFilteredResponse.items);
									$scope.isNoMatchedOffers = !$scope.isEmptyState;
								},
								function (error) {
									console.error(error);
								});
						}
					});
			} else {
				specialOfferService.fetchByCompany($scope.companyOid, $scope.filters, $scope.pagination.currentPage, 10)
					.then(function (response) {
						setPaginationValues(response);
						$scope.specialOffers = response.items;
						$scope.isEmptyState = _.isEmpty($scope.specialOffers);
						$scope.isNoMatchedOffers = false;
					},
					function (error) {
						console.error(error);
					});
			}

			$scope.hideProgressBar();
			
			if($cookies.get(UPGRADE_CAR_MODAL)){
				hideUpgradeModal();
			}
		};

		$scope.closeUpgradeCarModal = function(){
			$cookies.put(UPGRADE_CAR_MODAL,'checked');
			hideUpgradeModal();
		};

		function hideUpgradeModal(){
			var upgradeModal = document.getElementById('upgradeCarModal');

			upgradeModal.classList.remove('-show-modal');
		}

		function setPaginationValues(page){
			$scope.pagination = {
				itemsPerPage: page.itemsPerPage,
				currentPage: page.currentPage,
				numPages: Math.floor(page.totalItems / page.itemsPerPage) +
				(page.totalItems / page.itemsPerPage > 0 ? 1 : 0),
				totalItems: page.totalItems
			};
		}

		$scope.create = function (newOfferType) {
			gaInfo.send('Seleccionar_promo');
			$location.path(specialOfferUrlsService.newOfferUrl($routeParams.companyOid, newOfferType));
		};

		$scope.clone = function (specialOffer) {
			var underscoreTypedName = /(_)[A-Za-z]+/;
			var specialOfferType = specialOffer.specialOfferType
				.replace(underscoreTypedName, '')
				.toLowerCase();

			gaInfo.send('Clonar', specialOffer);
			$location
				.path(specialOfferUrlsService.newOfferUrl($routeParams.companyOid, specialOfferType))
				.search({clone: specialOffer.oid});
		};

		$scope.remove = function (specialOffer) {
			gaInfo.send('Intencion_eliminar', specialOffer);
			$scope.showModal('REMOVE_SPECIAL_OFFER_TITLE', 'REMOVE_SPECIAL_OFFER_MESSAGE', function () {
				specialOfferService.remove(specialOffer)
					.then(function (response) {
						gaInfo.send('Eliminar_promo', specialOffer);
						notificationService.displayToast('specialOffers.toast.removedOfferTitle', 'specialOffers.toast.removedOfferMessage', {'name': specialOffer.name});
						$scope.initialize();
					}, 
					function (error) {
						console.log(error);
					});
			});
		};

		$scope.changePage = function(){
			$scope.getSpecialOffers();
			$window.scrollTo(0, 0);
		};

		$scope.paginationFromNumber = function () {
			return 1 + (($scope.pagination.currentPage - 1) * $scope.pagination.itemsPerPage);
		};

		$scope.paginationToNumber = function () {
			return $scope.paginationFromNumber() + $scope.specialOffers.length -1;
		};

		$scope.paginationTotalOffertItems = function(){
			return $scope.pagination.totalItems;
		};

		$scope.moderate = function (specialOffer, status) {
			if (status === 'REJECTED') {
				gaModerate.send('Intencion_rechazar_promocion', specialOffer, 'Pantalla_promociones');
				$scope.showModal('REJECT_SPECIAL_OFFER_TITLE', 'REJECT_SPECIAL_OFFER_MESSAGE', function () {
					gaModerate.send('Rechazar_promocion', specialOffer, 'Pantalla_promociones');
					specialOfferService
						.moderate(specialOffer.companyOid, specialOffer.oid, status)
						.then(function (response) {
							notificationService.displayToast('specialOffers.toast.REJECTED_SPECIAL_OFFER_TITLE', 'specialOffers.toast.REJECTED_SPECIAL_OFFER_MESSAGE',
								{'name': specialOffer.name});
							$scope.initialize();
						}, function (error) {
							console.log(error);
						});
				});
			}

			if (status === 'APPROVED') {
				gaModerate.send('Aprobar_promocion', specialOffer, 'Pantalla_promociones');
				specialOfferService
					.moderate(specialOffer.companyOid, specialOffer.oid, status)
					.then(function () {
						notificationService.displayToast('specialOffers.toast.APPROVED_SPECIAL_OFFER_TITLE', 'specialOffers.toast.APPROVED_SPECIAL_OFFER_MESSAGE',
							{'name': specialOffer.name});
						$scope.initialize();
					}, function (error) {
						console.log(error);
					});
			}
		};

		function promoGa() {
			var category = 'Autos_promociones';
			var mapInfo = {
				'Seleccionar_promo': function (eventName) {
					gaService.notify(category, eventName, [$scope.companyOid, 'discount']);
				},
				'Intencion_eliminar': function (eventName, specialOffer) {
					gaService.notify(category, eventName, [$scope.companyOid, specialOffer.approvalStatus, 'discount']);
				},
				'Eliminar_promo': function (eventName, specialOffer) {
					gaService.notify(category, eventName, [$scope.companyOid, specialOffer.approvalStatus, 'discount']);
				},
				'Listado_ver_detalle': function (eventName, specialOffer) {
					gaService.notify(category, eventName, [$scope.companyOid, specialOffer.name]);
				},
				'Listado_ocultar_detalle': function (eventName, specialOffer) {
					gaService.notify(category, eventName, [$scope.companyOid, specialOffer.name]);
				},
				'Clonar': function (eventName, specialOffer) {
					gaService.notify(category, eventName, [$scope.companyOid, specialOffer.approvalStatus, 'discount']);
				},
				'Filtrar': function (eventName, filter) {
					gaService.notify(category, eventName, [$scope.companyOid, filter]);
				}
			}
			
			return {
				send: function (eventName, param1) {
					mapInfo[eventName].call(mapInfo, eventName, param1);
				}
			}
		}

		var gaInfo = promoGa();

		$scope.notifyGA = function (eventName, param) {
			gaInfo.send(eventName, param);
		}

		$scope.getLanguage = function(){
			return $rootScope.lang.name;
		}

		$scope.initialize();

	}]);



//////////////////
// WEBPACK FOOTER
// ./public/app/controllers/special_offers_controller.js
// module id = 910
// module chunks = 3